export function quizUniverseRoundsAnimationContent() {
    //
    // list of floors on a round page visible by delay
    //

    const roundListWrapper = document.querySelector('.round-progress .progress-items');

    if (!roundListWrapper) { return; }

    const floorListItem = document.querySelector('.round-progress .floor.hidden-item');
    const floorDelay = parseInt(roundListWrapper.dataset.delaySeconds) * 1000;

    const showElementWithDelay = (floor, floorDelay) => {
        setTimeout(function () {
            floor.classList.remove('hidden-item');
        }, floorDelay);
    }

    if (floorListItem) {
        showElementWithDelay(floorListItem, floorDelay);
    }
}

export function quizUniverseProgressAnimationContent() {
    //
    // user progress steps displaying on a round page visible by delay
    //

    const playerProgressWrapper = document.querySelector('.player-progress-wrapper');

    if (!playerProgressWrapper) { return; }

    const playerProgress = playerProgressWrapper.querySelector('.player-progress');
    const playerProgressItems = playerProgress.querySelectorAll('img.hidden');
    const visibilityDelay = parseInt(playerProgressWrapper.dataset.delaySeconds) * 1000;
    const showElementWithDelay = (i, step, visibilityDelay) => {
        setTimeout(function () {
            step.style.display = 'inline-block';
            step.style.visibility = 'visible';
            step.style.opacity = '1';
        }, visibilityDelay);
    }

    if (playerProgressItems.length) {
        let delayPerStep = 0;

        for (let i = 0; i <= playerProgressItems.length - 1; i++) {
            showElementWithDelay(i, playerProgressItems[i], delayPerStep);
            delayPerStep += visibilityDelay;
        }
    }
}

export function quizUniverseUserScoreAnimation() {
    const userScoreWrapper = document.querySelector('.round-info')

    if (!userScoreWrapper) { return; }

    const userScoreElements = userScoreWrapper.querySelectorAll('[data-score]');

    userScoreElements.forEach(item => {
        const userScoreAnimationTime = item.dataset.interval ? Number(item.dataset.interval) * 100 : 100;
        let startAnimationScore = Number(item.innerHTML);

        let userScoreAnimationInterval = setInterval(() => {
            if (startAnimationScore >= Number(item.dataset.score)) {
                item.innerHTML = item.dataset.score;
                clearInterval(userScoreAnimationInterval);
            }

            item.innerHTML = startAnimationScore;
            startAnimationScore += 10;
        }, userScoreAnimationTime);
    });
}